import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function ForbiddenPage() {
  return (
    <div className="bg-[#11161a] text-white min-h-[70vh] flex items-center justify-center py-20 px-4">
      <Helmet>
        <title>Adgang nægtet (403) - T.H Byg</title>
      </Helmet>

      <div className="max-w-xl text-center space-y-6">
        <div className="inline-flex h-20 w-20 items-center justify-center rounded-2xl bg-[#d92323] text-white text-3xl font-black shadow-2xl">
          403
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Adgang nægtet
        </h1>

        <p className="text-slate-300 text-base leading-relaxed">
          Du har ikke tilladelse til at tilgå denne ressource. Brug venligst links nedenfor til at navigere videre på T.H Bygs hjemmeside.
        </p>

        <div className="pt-4 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="rounded-full bg-[#d92323] px-6 py-3.5 text-sm font-bold text-white hover:bg-[#b81b1b] transition-all"
          >
            Gå til Forsiden
          </Link>
          <Link
            to="/kontakt"
            className="rounded-full bg-slate-800 border border-slate-700 px-6 py-3.5 text-sm font-bold text-white hover:bg-slate-700 transition-all"
          >
            Kontakt T.H Byg
          </Link>
        </div>
      </div>
    </div>
  );
}
